import React from "react"
import styled from "styled-components"
const StyledPageHeader = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: auto;
  // background-color: rgba(200, 200, 200, 0.1);
  & > p {
    padding: 1rem;
    font-size: 1.2rem;
  }
`
const PageHeader = () => {
  return (
    <StyledPageHeader>
      <p>Screw Simulator</p>
    </StyledPageHeader>
  )
}
export default PageHeader
